<div
	class="outer-box"
	*ngIf="counts?.[MATTER_FILE_TYPE.PURCHASE] || showIfZero"
>
	<div class="inner-label purchase">P</div>
	<div class="inner-count">
		{{ counts?.[MATTER_FILE_TYPE.PURCHASE] || zeroDisplayAs }}
	</div>
</div>
<div class="outer-box" *ngIf="counts?.[MATTER_FILE_TYPE.SALE] || showIfZero">
	<div class="inner-label sale">S</div>
	<div class="inner-count">
		{{ counts?.[MATTER_FILE_TYPE.SALE] || zeroDisplayAs }}
	</div>
</div>
<div
	class="outer-box"
	*ngIf="counts?.[MATTER_FILE_TYPE.REFINANCE] || showIfZero"
>
	<div class="inner-label refinance">R</div>
	<div class="inner-count">
		{{ counts?.[MATTER_FILE_TYPE.REFINANCE] || zeroDisplayAs }}
	</div>
</div>
